<template>
    <div>
        <Head title="Створити Блоки риболовлі"/>
        <h1 class="mb-8 text-3xl font-bold">
            <Link
                class="text-indigo-400 hover:text-indigo-600"
                :href="$route('attributes.index')"
            >
                Атрибути риболовлі
            </Link>
            <span class="text-indigo-400 font-medium">/</span> Створення атрибуту
        </h1>
        <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                        <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full"
                                    label="Назва"/>
                        <text-input v-model="form.price" :error="form.errors.price" class="pb-8 pr-6 w-full lg:w-1/2"
                                    label="Ціна" type="number"/>
                        <checkbox v-model="form.optional" :error="form.errors.optional"
                                  class="pb-8 pr-6 w-full lg:w-1/2"
                                  label="Чи може користувач обирати опцію"/>
                        <checkbox v-model="form.cabinet_only" :error="form.errors.cabinet_only"
                                  class="pb-8 pr-6 w-full lg:w-1/2"
                                  label="Тільки з кабінету"/>

                        <div class="flex w-full flex-col lg:flex-row">
                            <div class="flex-1 pt-4 mr-6">
                                <label for="lakesTable" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Озера на яких наявний атрибут:</label>
                                <table id="lakesTable" class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                                    <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                    <tr>
                                        <th scope="col" class="p-4">
                                            <div class="flex items-center">
                                                <input id="checkAllLakes" type="checkbox" @change="checkAllLakes($event.target.checked)" class="w-4 h-4">
                                                <label for="checkAllLakes" class="ml-2 capitalize">Всі</label>
                                            </div>
                                        </th>
                                        <th scope="col" class="py-3 px-6 capitalize">Назва озера</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="lake in lakes" :key="lake.id" class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                                        <td class="w-4 p-4">
                                            <input type="checkbox" v-model="form.lakesId" :value="lake.id" class="w-4 h-4">
                                        </td>
                                        <td class="py-3 px-6">{{ lake.name }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="flex w-full flex-col lg:flex-row">
                            <div class="flex-1 pt-4 mr-6">
                                <label for="pointsTable" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Точки на яких наявний атрибут:</label>
                                <table id="pointsTable" class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                                    <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                    <tr>
                                        <th scope="col" class="p-4">
                                            <div class="flex items-center">
                                                <input id="checkAllPoints" type="checkbox" @change="checkAllPoints($event.target.checked)" class="w-4 h-4">
                                                <label for="checkAllPoints" class="ml-2 capitalize">Всі</label>
                                            </div>
                                        </th>
                                        <th scope="col" class="py-3 px-6 capitalize">Назва точки</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="point in points" :key="point.id" class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                                        <td class="w-4 p-4">
                                            <input type="checkbox" v-model="form.pointsId" :value="point.id" class="w-4 h-4">
                                        </td>
                                        <td class="py-3 px-6">{{ point.name }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">
                        Створити атрибут
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import Checkbox from "@/Shared/Checkbox"
import axios from "axios";
import SelectInput from "@/Shared/SelectInput.vue";

export default {
    components: {
        SelectInput,
        Checkbox,
        Head,
        Link,
        LoadingButton,
        TextInput,
    },
    props: {
        lakes: Array,
    },
    layout: Layout,
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                title: '',
                price: '',
                optional: false,
                cabinet_only: false,
                lakesId: [],
                pointsId: [],
            }),
            lakes: [],
            points: [],
        }
    },
    watch: {
        'form.lakesId'() {
            this.fetchPoints()
        },
    },
    methods: {
        store() {
            this.form.post(this.$route('attributes.store'))
        },
        async fetchPoints() {
            this.points = []
            if (this.form.lakesId) {
                const response = await axios.post(this.$route('all.lakes.points', {
                    lakes: this.form.lakesId
                }))
                this.points = await response.data.points;
            }
        },
        async fetchLakes() {
            const response = await axios.get(this.$route('all.lakes'))
            this.lakes = await response.data.lakes;
            await this.fetchPoints()
        },
        checkAllLakes(isChecked) {
            this.form.lakesId = isChecked ? [...this.lakes.map(lake => {
                return lake.id
            })] : []
        },
        checkAllPoints(isChecked) {
            this.form.pointsId = isChecked ? [...this.points.map(point => {
                return point.id
            })] : []
        },
    },
    mounted() {
        this.fetchLakes()
    }
}
</script>
